export default __webpack_public_path__ + "static/media/3ed43abace52dadad5ae1ec42587b3c5.svg";